export const ENDPOINTS = {
  CREATE_META_SITE: '/api/create-meta-site',
  UPLOAD_SITE_MEDIA: '/api/upload-site-media',
  GENERATE_MOCKUPS: '/api/generate-mockups',
  ATTACH_SITE_TEMPLATE: '/api/attach-site-template',
  INSTALL_SITE_APPS: '/api/install-site-apps',
  GET_SITE_URLS: '/api/get-site-urls',
  ADD_STORE_PRODUCTS: '/api/add-store-products',
  GET_PRODUCTS_COUNT: '/api/get-products-count',
  GET_RECOMMENDED_PRODUCTS: '/api/get-recommended-products',
  GET_INSTALLED_APPS: '/api/get-installed-apps',
  GET_SITE_IMAGES: '/api/get-site-images',
  INJECT_COMPONENT_CORE: '/api/inject-component-core',
};
